import { useQuery } from "@tanstack/react-query";

import { ApiManager } from "services/api";

export interface IOpenWidgetStateResult {
  OpenWidgetInOrganization: boolean;
  connected: boolean;
  installed: boolean;
  snippetCode?: string;
}

export enum OpenWidgetState {
  NotInOrganization = "notInOrganization",
  Unconnected = "unconnected",
  Connected = "connected",
  Installed = "installed",
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapResultToState = (result: IOpenWidgetStateResult) => {
  if (!result.OpenWidgetInOrganization) {
    return OpenWidgetState.NotInOrganization;
  }

  if (!result.connected) {
    return OpenWidgetState.Unconnected;
  }

  if (!result.installed) {
    return OpenWidgetState.Connected;
  }

  return OpenWidgetState.Installed;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getOpenWidgetState = async () => {
  const { error, result } = await ApiManager.integrationsApi.fetchOpenWidget();
  if (error) {
    throw error;
  }
  const { snippetCode } = result;

  return { state: mapResultToState(result), snippetCode };
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useOpenWidgetState = () =>
  useQuery({
    queryKey: ["openWidgetState"],
    queryFn: getOpenWidgetState,
  });
